var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84219 19V19.15H5.99219H19.9942H20.1442L20.1442 19L20.1422 4.99998L20.1422 4.85H19.9922H5.99219H5.84219V5V19ZM10.8861 14.1061L11.0084 14.2284L11.1122 14.09L13.9892 10.2539L18.7007 16.85H7.29219L10.0084 13.2284L10.8861 14.1061ZM5.99219 3.15H19.9922C21.0123 3.15 21.8422 3.97984 21.8422 5V19C21.8422 20.0202 21.0123 20.85 19.9922 20.85H5.99219C4.97203 20.85 4.14219 20.0202 4.14219 19V5C4.14219 3.97984 4.97203 3.15 5.99219 3.15ZM10.8422 9.5C10.8422 10.2456 10.2378 10.85 9.49219 10.85C8.7466 10.85 8.14219 10.2456 8.14219 9.5C8.14219 8.75442 8.7466 8.15 9.49219 8.15C10.2378 8.15 10.8422 8.75442 10.8422 9.5Z",
    fill: "#139CFF",
    stroke: "#EFF0F6",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.3478280dc7cec4c7a6cc97517f2a5d6c.svg";
export { ForwardRef as ReactComponent };